/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable max-len */
/* eslint-disable default-case */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation, useParams } from 'react-router-dom';
import NavBar from '../sharedComponents/NavBar';
import '../../styles/ChatScreen.css';
import data from '../../assets/conversation_mockup.json';
import Workspaces from '../sharedComponents/Workspaces.tsx';
import Content from '../sharedComponents/Content';
import Grid from '@mui/material/Grid';
import { useChatContext } from '../../contexts/ChatContext';
import { CanvasPanelProvider } from '../../contexts/CanvasPanelContext';
import { getAllUsers, getAllAgents, getInformation, getUser } from '../../resources/api.resource.ts';
import store from '../../utils/store.ts';
import { transformUser, transformAgent, buildUsersMap } from '../../utils/userTransformers';
// import { fetchChatHistory } from '../../hooks/fetchChatHistory';

const ChatScreen = ({ logedInUserMail, logedInUserName }) => {
  const [selectedNavBar, setSelectedNavBar] = useState(0);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedSearchType, setSelectedSearchType] = useState('Hybrid Search');
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [newChatFlag, setNewChatFlag] = useState(() => {
    const param = queryParams.get("new_chat");
    return param === "true" || param === null;
  });
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [hasMessages, setHasMessages] = useState(false);
  const { setGroupedChatHistory, setChatDetails } = useChatContext();
  const { collaboration_id } = useParams();
  const [allUsersMap, setAllUsersMap] = useState({});
  const [collaborations, setCollaborations] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
  const [isLoadingData, setIsLoadingData] = useState(true);
  const [computedCollaborationId, setComputedCollaborationId] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoadingData(true);
      try {
        // Fetch current user, users and agents in parallel
        const [user, rawUsers, rawAgents] = await Promise.all([
          getUser(),
          getAllUsers(),
          getAllAgents().catch(err => {
            console.warn('Failed to fetch agents, continuing with users only:', err);
            return [];
          })
        ]);

        // Transform to internal format
        const usersWithType = rawUsers.map(transformUser);
        const agentsWithType = rawAgents.map(transformAgent);
        const allUsers = [...usersWithType, ...agentsWithType];

        // Create map for lookups
        const map = buildUsersMap(allUsers);
        setAllUsersMap(map);
        setCurrentUser(user);

        // Fetch collaborations
        const collabs = await getInformation();
        setCollaborations(collabs);

        // Dispatch to Redux
        store.dispatch({
          type: 'set',
          collaborations: collabs,
          allUsers: allUsers
        });

      } catch (err) {
        console.error("Error fetching data in ChatScreen:", err);
      } finally {
        setIsLoadingData(false);
      }
    };

    fetchData();
  }, []);

  // Compute collaboration ID for Chat view (navbar 0)
  useEffect(() => {
    if (selectedNavBar === 0 && !collaboration_id && collaborations.length > 0 && Object.keys(allUsersMap).length > 0) {
      // Find first DM with an agent
      const dmCollabs = collaborations.filter(c => c.collaborationType === "dm");
      
      for (const dm of dmCollabs) {
        // Check if any memberUid is an agent
        const hasAgent = dm.memberUids?.some(uid =>
          allUsersMap[uid.toLowerCase()]?.userType === 'agent'
        );

        if (hasAgent) {
          setComputedCollaborationId(dm.collab_instances[0] ? dm.collab_instances[0].id : dm.collaborationId);
          return;
        }
      }

      // No agent DM found
      setComputedCollaborationId(null);
    } else if (selectedNavBar === 1 || collaboration_id) {
      // Reset for Collaborations view or when URL param exists
      setComputedCollaborationId(null);
    }
  }, [selectedNavBar, collaboration_id, collaborations, allUsersMap]);

  return (
    <div className="chat-container chat-route">
      <Grid container sx={{ width: '100%' }} spacing={0}>
        <Grid item size="xs">
          <NavBar changeSelectedNavBar={setSelectedNavBar} logedInUserMail={logedInUserMail} logedInUserName={logedInUserName} currentUser={currentUser} selectedNavBar={selectedNavBar} />
        </Grid>
        <Grid item size="grow">
          <div className="chat-body">
            {isLoadingData ? (
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                width: '100%',
                backgroundColor: '#f5f5f5'
              }}>
                <div style={{
                  textAlign: 'center',
                  padding: '40px'
                }}>
                  <div style={{
                    width: '50px',
                    height: '50px',
                    border: '4px solid #e0e0e0',
                    borderTop: '4px solid #0857c3',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite',
                    margin: '0 auto 20px'
                  }} />
                  <p style={{
                    color: '#555',
                    fontSize: '16px',
                    fontFamily: 'Proxima Nova',
                    margin: 0
                  }}>
                    Loading...
                  </p>
                  <style>{`
                    @keyframes spin {
                      0% { transform: rotate(0deg); }
                      100% { transform: rotate(360deg); }
                    }
                  `}</style>
                </div>
              </div>
            ) : (
              <CanvasPanelProvider>
                <Workspaces
                  fetchedMessages={data}
                  initialCollaborationId={collaboration_id || computedCollaborationId}
                  showLeftPanel={selectedNavBar === 1}
                  allUsersMap={allUsersMap}
                  collaborations={collaborations}
                  currentUser={currentUser}
                />
              </CanvasPanelProvider>
            )}
          </div>
        </Grid>
      </Grid>

      {/* {!hasMessages && (
        <footer className="chat-footer">
          These are AI generated content, check before using
        </footer>
      )} */}
    </div>
  );
};

ChatScreen.propTypes = {
  logedInUserMail: PropTypes.string.isRequired,
};

export default ChatScreen;
